import { createSelector } from 'reselect';
import { quoteState } from '../selectors';
import cloneDeep from 'lodash/cloneDeep';

export const makeCreditRows = creditLines => {
  return cloneDeep(creditLines).map(credit => {
    const { operationId, workSummary, fixedCostWithVAT, coupon, type } = credit;
    const row = ({
      workSummary,
      fixedCostWithVAT: fixedCostWithVAT / 100,
      key: `credit-row-${operationId}`,
      type,
      coupon,
      className: ['credit-row', 'footer-row'],
      editable: false,
    });
    return row;
  });
};

export default function creditSelector() {
  return createSelector(
    quoteState,
    state => {
      if (!state) return [];
      return makeCreditRows(
        state
          .get('lineItems')
          .filter(li => ['credit'].includes(li.get('type')))
          .toJS()
      );
    }
  );
}

